import { Box } from '@chakra-ui/react'

import { NavigationButton } from '@/shared/ui/NavigationButton'

interface RoomInfoTabsNavigationButtonProps {
	direction: 'left' | 'right'
	id: string
}

/**
 * Component with navigation button for room info tabs
 *
 * @author Ivan Shchedrovskyi
 */
export const RoomInfoTabsNavigationButton = ({
	id,
	direction
}: RoomInfoTabsNavigationButtonProps) => {
	return (
		<Box
			id={id}
			display="flex"
			alignItems="center"
			pos="absolute"
			left={direction === 'left' ? 0 : 'unset'}
			right={direction === 'right' ? 0 : 'unset'}
			top={0}
			bottom={0}
			zIndex="docked"
			w="5rem"
			pl="1.25rem"
			pointerEvents="none"
			bgGradient={`linear(to-${
				direction === 'left' ? 'l' : 'r'
			}, transparent, white)`}
			transition="opacity 250ms ease"
			sx={{
				'&.swiper-button-disabled': {
					opacity: 0,
					'>button': {
						pointerEvents: 'none'
					}
				}
			}}
		>
			<NavigationButton
				classNames={{
					base: 'bg-white w-9 h-9 rounded-full',
					icon: 'size-4!'
				}}
				size="icon-sm"
				// colorScheme="brand"
				direction={direction}
				aria-label={`slider navigation to the ${direction}`}
				data-wwt-id={`room-info-tabs__scroll-${direction}--button`}
			/>
		</Box>
	)
}
